import { ExportOutlined, LoginOutlined } from '@ant-design/icons';
import { Button, Form, Space } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { StyledCard, StyledForm, StyledFormItem } from './styled';

const Login = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation('auth');

  const onFinish = (values) => {
    console.log('Success:', values);
  };

  // TODO Supprimer cette log et la variable d'environement utiliser pour les tests de déploiement
  console.log(import.meta.env.VITE_TEST);

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleSSOLogin = () => {
    setIsLoading(true);
    // Stocker l'URL actuelle pour la redirection post-authentification
    const currentPath = window.location.pathname;
    if (currentPath !== '/auth/login') {
      sessionStorage.setItem('redirectPath', currentPath);
    }
    navigate('/auth/sso');
  };

  console.log('VITE_OAUTH_AUTHORITY', import.meta.env.VITE_OAUTH_AUTHORITY);

  return (
    <StyledCard
      size="small"
      title={t('login.welcome')}
      extra={
        <Space>
          <Button
            iconPosition="end"
            icon={<ExportOutlined />}
            onClick={() =>
              window.open(
                `${import.meta.env.VITE_PROMETHEE_BACK_BASE_URL}/admin/`,
                '_blank',
                'noopener noreferrer'
              )
            }
            type="link"
            size="small"
          >
            BO Promethee
          </Button>

          <Button
            iconPosition="end"
            icon={<ExportOutlined />}
            onClick={() =>
              window.open(
                `${import.meta.env.VITE_BO_BASE_URL}/admin/`,
                '_blank',
                'noopener noreferrer'
              )
            }
            type="link"
            size="small"
          >
            BO
          </Button>
        </Space>
      }
    >
      <StyledForm
        form={form}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        layout="vertical"
      >
        <StyledFormItem label="">
          <Button
            onClick={handleSSOLogin}
            type="primary"
            htmlType="button"
            loading={isLoading}
            icon={<LoginOutlined />}
            size="large"
            style={{ width: '100%' }}
          >
            {t('login.button')}
          </Button>
        </StyledFormItem>
      </StyledForm>
    </StyledCard>
  );
};

export default Login;
